// extracted by mini-css-extract-plugin
export default {"root":"_3qe-gVKI","contentAlignLeft":"_24kddiH0"};